export const DOCS_URL = 'https://docs.appsvio.com/multilevel-cascading-select';
export const CONTACT_URL = 'https://get.support.appsvio.com/servicedesk/customer/portal/9/group/19';

export enum FieldType {
    MULTILEVEL = 'multilevel-cascading-custom-field-type',
    REGEX = 'custom-field-regex-type',
}
